module.exports = __webpack_public_path__ + "static/media/IEA_logo.01ddf0f0.png";